import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { PicturePresentation } from '../Picture/PicturePresentation.js';
import { hostClass } from './GallerySliderItem.styles.js';

var defaultProps = {};
var GallerySliderItemPresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      children = props.children,
      className = props.className,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      pictureAlt = props.pictureAlt,
      pictureSource = props.pictureSource,
      pictureImgSrc = props.pictureImgSrc,
      pictureImgAttrs = props.pictureImgAttrs,
      look = props.look;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(look), look), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement(PicturePresentation, {
    imgSrc: pictureImgSrc,
    source: pictureSource,
    alt: pictureAlt,
    imgAttrs: pictureImgAttrs
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-content")
  }, children));
}, defaultProps);

export { GallerySliderItemPresentation, defaultProps };
